export function toTime(t) {
  let sec: number | string = t % 60;
  let min: number | string = (t - sec) / 60;
  sec = Math.floor(sec);
  if (sec < 10) {
    sec = "0" + sec;
  }
  if (min < 10) {
    min = "0" + min;
  }
  return min + ":" + sec;
}